// GENERATED FILE — do not edit.
//
// Source:      packages/maptool/maps/rooftops.txt
// Regenerate:  npm run maps -w @prop-hunt/maptool
// mapHash:     0xe6a51a8f
//
// 40 x 30 cells at 2m = 80m x 60m (x -40..40, z -30..30)
// 39 collision solids, 42 props, 12 spawns
// 10 elevation tiers at 0.5m, ground 0m..4.5m
//
// Editing this file by hand desynchronises it from the ASCII plan, which is
// the artefact the level actually lives in. Edit the source and regenerate.

import { MAP_FORMAT_VERSION, type GameMap } from "../mapfmt.js";

export const ROOFTOPS_MAP: GameMap = {
  formatVersion: MAP_FORMAT_VERSION,
  name: "rooftops",
  solids: [
    { x: 0, y: -1, z: -29, w: 80, h: 1, d: 2 },
    { x: -39, y: -1, z: 1, w: 2, h: 1, d: 58 },
    { x: 39, y: -1, z: 1, w: 2, h: 1, d: 58 },
    { x: -1, y: -1, z: 14, w: 6, h: 1, d: 32 },
    { x: -21, y: -1, z: 17, w: 34, h: 1, d: 26 },
    { x: 20, y: -1, z: 29, w: 36, h: 1, d: 2 },
    { x: -21, y: -1, z: 3, w: 34, h: 1.5, d: 2 },
    { x: -21, y: -1, z: 1, w: 34, h: 2, d: 2 },
    { x: -21, y: -1, z: -14, w: 34, h: 2.5, d: 28 },
    { x: -3, y: -1, z: -15, w: 2, h: 3, d: 26 },
    { x: -1, y: -1, z: -15, w: 2, h: 3.5, d: 26 },
    { x: 19, y: -1, z: -15, w: 38, h: 4, d: 26 },
    { x: 20, y: -1, z: -1, w: 36, h: 4.5, d: 2 },
    { x: 20, y: -1, z: 1, w: 36, h: 5, d: 2 },
    { x: 20, y: -1, z: 15, w: 36, h: 5.5, d: 26 },
    { x: 0, y: 0, z: -29, w: 80, h: 8.5, d: 2 },
    { x: -39, y: 0, z: 1, w: 2, h: 8.5, d: 58 },
    { x: 39, y: 0, z: 1, w: 2, h: 8.5, d: 58 },
    { x: -1, y: 0, z: 1, w: 6, h: 8.5, d: 6 },
    { x: -17, y: 0, z: 13, w: 6, h: 8.5, d: 6 },
    { x: -36, y: 0, z: 13, w: 4, h: 8.5, d: 2 },
    { x: -26, y: 0, z: 13, w: 8, h: 8.5, d: 2 },
    { x: -23, y: 0, z: 22, w: 2, h: 8.5, d: 16 },
    { x: -31, y: 0, z: 29, w: 14, h: 8.5, d: 2 },
    { x: 8, y: 0, z: 29, w: 60, h: 8.5, d: 2 },
    { x: -26, y: 1.5, z: -18, w: 8, h: 7, d: 8 },
    { x: -11, y: 1.5, z: -9, w: 6, h: 7, d: 6 },
    { x: 14, y: 3, z: -20, w: 8, h: 5.5, d: 8 },
    { x: 29, y: 3, z: -9, w: 6, h: 5.5, d: 6 },
    { x: 13, y: 4.5, z: 14, w: 6, h: 4, d: 8 },
    { x: 27, y: 4.5, z: 13, w: 6, h: 4, d: 2 },
    { x: 36, y: 4.5, z: 13, w: 4, h: 4, d: 2 },
    { x: 25, y: 4.5, z: 21, w: 2, h: 4, d: 14 },
    { x: -33, y: 1.5, z: -3, w: 10, h: 1, d: 2 },
    { x: -20, y: 1.5, z: -3, w: 8, h: 1, d: 2 },
    { x: -8, y: 1.5, z: -3, w: 8, h: 1, d: 2 },
    { x: 3, y: 4.5, z: 6, w: 2, h: 1, d: 4 },
    { x: 3, y: 4.5, z: 17, w: 2, h: 1, d: 10 },
    { x: 3, y: 4.5, z: 27, w: 2, h: 1, d: 2 },
  ],
  props: [
    { prop: 3, x: 5, y: 3, z: -25, yaw: 0.785398 },
    { prop: 3, x: 23, y: 3, z: -25, yaw: 0 },
    { prop: 6, x: -35, y: 1.5, z: -23, yaw: 3.141593 },
    { prop: 2, x: -19, y: 1.5, z: -23, yaw: 3.141593 },
    { prop: 6, x: -9, y: 1.5, z: -23, yaw: 0.785398 },
    { prop: 2, x: 33, y: 3, z: -23, yaw: 1.570796 },
    { prop: 5, x: 7, y: 3, z: -19, yaw: 5.497787 },
    { prop: 5, x: 25, y: 3, z: -19, yaw: 0 },
    { prop: 3, x: -35, y: 1.5, z: -17, yaw: 0.785398 },
    { prop: 3, x: -17, y: 1.5, z: -17, yaw: 0 },
    { prop: 6, x: -5, y: 1.5, z: -13, yaw: 3.141593 },
    { prop: 2, x: 7, y: 3, z: -13, yaw: 1.570796 },
    { prop: 5, x: 31, y: 3, z: -13, yaw: 4.712389 },
    { prop: 5, x: -33, y: 1.5, z: -11, yaw: 5.497787 },
    { prop: 5, x: -19, y: 1.5, z: -11, yaw: 4.712389 },
    { prop: 6, x: 5, y: 3, z: -7, yaw: 0 },
    { prop: 2, x: -33, y: 1.5, z: -5, yaw: 1.570796 },
    { prop: 2, x: 21, y: 3, z: -5, yaw: 5.497787 },
    { prop: 3, x: 35, y: 3, z: -3, yaw: 3.926991 },
    { prop: 4, x: -21, y: 1, z: 1, yaw: 2.356194 },
    { prop: 4, x: -11, y: 1, z: 1, yaw: 3.141593 },
    { prop: 4, x: 9, y: 4, z: 1, yaw: 1.570796 },
    { prop: 4, x: 19, y: 4, z: 1, yaw: 5.497787 },
    { prop: 4, x: 29, y: 4, z: 1, yaw: 0 },
    { prop: 1, x: -35, y: 0, z: 7, yaw: 3.926991 },
    { prop: 1, x: -29, y: 0, z: 7, yaw: 1.570796 },
    { prop: 6, x: -15, y: 0, z: 7, yaw: 2.356194 },
    { prop: 1, x: -9, y: 0, z: 7, yaw: 0 },
    { prop: 4, x: -1, y: 0, z: 7, yaw: 3.141593 },
    { prop: 1, x: 9, y: 4.5, z: 7, yaw: 5.497787 },
    { prop: 5, x: 17, y: 4.5, z: 7, yaw: 2.356194 },
    { prop: 1, x: 35, y: 4.5, z: 7, yaw: 1.570796 },
    { prop: 2, x: -7, y: 0, z: 9, yaw: 4.712389 },
    { prop: 2, x: -11, y: 0, z: 19, yaw: 2.356194 },
    { prop: 4, x: -1, y: 0, z: 21, yaw: 5.497787 },
    { prop: 1, x: 21, y: 4.5, z: 21, yaw: 1.570796 },
    { prop: 5, x: -29, y: 0, z: 23, yaw: 1.570796 },
    { prop: 1, x: -17, y: 0, z: 23, yaw: 3.141593 },
    { prop: 6, x: 31, y: 4.5, z: 23, yaw: 3.141593 },
    { prop: 3, x: -13, y: 0, z: 25, yaw: 2.356194 },
    { prop: 6, x: 13, y: 4.5, z: 27, yaw: 2.356194 },
    { prop: 3, x: 19, y: 4.5, z: 27, yaw: 3.141593 },
  ],
  spawns: [
    { x: -35, y: 0, z: 19, yaw: 0, team: "hider" },
    { x: -31, y: 0, z: 19, yaw: 0, team: "hider" },
    { x: -27, y: 0, z: 19, yaw: 0, team: "hider" },
    { x: 29, y: 4.5, z: 19, yaw: 0, team: "hunter" },
    { x: 33, y: 4.5, z: 19, yaw: 0, team: "hunter" },
    { x: 37, y: 4.5, z: 19, yaw: 0, team: "hunter" },
    { x: -35, y: 0, z: 25, yaw: 0, team: "hider" },
    { x: -31, y: 0, z: 25, yaw: 0, team: "hider" },
    { x: -27, y: 0, z: 25, yaw: 0, team: "hider" },
    { x: 29, y: 4.5, z: 25, yaw: 0, team: "hunter" },
    { x: 33, y: 4.5, z: 25, yaw: 0, team: "hunter" },
    { x: 37, y: 4.5, z: 25, yaw: 0, team: "hunter" },
  ],
};
